import FMHLogo from '@strata/strata-ui/assets/logos/free-market-health-logo.svg?react';
import PropTypes from 'prop-types';

export const PrintHeader = ({ pageTitle }) => (
    <div className="print__header">
        <div>
            <FMHLogo title="Free Market Health Logo" className="print__logo" />
        </div>
        <div className="print__title">{`Agora: ${pageTitle}`}</div>
    </div>
);

PrintHeader.propTypes = {
    pageTitle: PropTypes.string.isRequired,
};
